import React from 'react';

import { TableRow, TableHeader } from '@unimed-fesp/components';

const TableUsuarioHeader = () => {
  return (
    <TableRow>
      <TableHeader minWidth={18} maxWidth={20} />
      <TableHeader maxWidth={300} minWidth={150}>
        Nome
      </TableHeader>
      <TableHeader maxWidth={120} minWidth={150}>
        Email
      </TableHeader>
      <TableHeader maxWidth={100} minWidth={80}>
        Tipo Perfil
      </TableHeader>
      <TableHeader maxWidth={90} minWidth={80}>
        Status
      </TableHeader>
    </TableRow>
  );
};

export default TableUsuarioHeader;
